// Anvil Core
import './anvil';
import Swiper from 'swiper/bundle';
import makeCalcAppHeight from './modules/vh-fix';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/* global gsap */
window.gsap = gsap;

/* global Swiper */
window.Swiper = Swiper;

/* Height fix for IOS mobile browser */
makeCalcAppHeight();

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll( 'button' ).forEach( e => {
		e.addEventListener( 'click', () => {
			e.focus();
		});
	});

	if (navigator.userAgent.indexOf('iPhone') > -1 ) {
		document
			.querySelector('[name=viewport]')
			.setAttribute('content', 'width=device-width, initial-scale=1, maximum-scale=1');
	}
});
